import {
  AiDraftActivityLogRenderer,
  useAiDraftRevision,
} from '../aiDraftActivityLog';

/** The host's activity log for one suggestion, kept in step with its changes. */
export function SuggestionActivityLog({
  aiDraftId,
  render,
}: {
  aiDraftId: string;
  render: AiDraftActivityLogRenderer;
}): JSX.Element {
  const revision = useAiDraftRevision(aiDraftId);
  return render({ aiDraftId, revision });
}
